import type { SectionSource, SourceKind } from "./types";

export const SOURCE_KIND_LABELS: Record<SourceKind, string> = {
  document: "Source document",
  figure: "Figure",
  table: "Table",
};

export const isDisplayItem = (kind: SourceKind) => kind !== "document";

/** What a source is called in the panel: a display item's label (and version), else the document's name. */
export function sourceName(source: Pick<SectionSource, "kind" | "label" | "version_label">, documentName: string | undefined): string {
  const fallback = documentName ?? "Document no longer in the Evidence Base";
  if (!isDisplayItem(source.kind)) return fallback;
  const label = source.label || `${SOURCE_KIND_LABELS[source.kind]} (${fallback})`;
  return source.version_label ? `${label} · ${source.version_label}` : label;
}
